import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { hash } from 'rsvp';

export default class ActivatorsRoute extends Route 
{
	@service store;
	
	async model(params)
	{
		const events = await this.store.findAll('Event');
		const activators = await this.store.findAll('Activator');

		for(const activator of activators)
		{
			const event = await activator.EventId;
			if(event != null)
			{
				this.store.findRecord('Event', event.id);
			}
		}

		return {
			events: events,
			activators: activators
		}
	}
}